/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function Brain(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M208.001,86.73157,208,72a40,40,0,0,0-80,0,40,40,0,0,0-80,0l-.001,14.73157a48.01968,48.01968,0,0,0,.00049,90.537L48,177.26685V184a40,40,0,0,0,80,0,40,40,0,0,0,80,0v-6.73315l.00049.0017a48.01968,48.01968,0,0,0,.00049-90.537Z"
        opacity={0.2}
      />
      <Line
        x1={128}
        y1={176}
        x2={128}
        y2={80}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M88,144a40,40,0,1,1-40,40v-6.73323"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M168,144a40,40,0,1,0,40,40v-6.7317"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M72,180H64A48.00813,48.00813,0,0,1,47.99924,86.73156L48,72a40,40,0,0,1,80,0V184"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M184,180h8a48.00813,48.00813,0,0,0,16.00076-93.26844L208,72a40,40,0,0,0-80,0"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M88,84v8a28,28,0,0,1-28,28"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M168,84v8a28,28,0,0,0,28,28"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Brain;
